var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Outline",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-1",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M19.723,9.732,12.3,17.157a1.05,1.05,0,0,1-.742.308H8.586a1.05,1.05,0,0,1-1.05-1.05v-2.97a1.05,1.05,0,0,1,.308-.742l7.425-7.425,2.97-2.97a1.05,1.05,0,0,1,1.485,0l2.97,2.97a1.05,1.05,0,0,1,0,1.485Zm1.177,5.13a1.05,1.05,0,1,1,2.1,0V18.8A4.2,4.2,0,0,1,18.8,23H6.2A4.2,4.2,0,0,1,2,18.8V6.2A4.2,4.2,0,0,1,6.2,2h3.937a1.05,1.05,0,1,1,0,2.1H6.2A2.1,2.1,0,0,0,4.1,6.2V18.8a2.1,2.1,0,0,0,2.1,2.1H18.8a2.1,2.1,0,0,0,2.1-2.1ZM9.636,13.879v1.485h1.485L17.5,8.99,16.01,7.5ZM17.5,6.02,18.98,7.5,20.465,6.02,18.98,4.535Z",
    transform: "translate(-2 -2)",
    fill: "#188cfb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dc08e564c3303920c0b76d83647ccf7f.svg";
export { ForwardRef as ReactComponent };